































































































































































































































































































































































































































































































































































































































































































































































































































import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Ota } from "@/shared/models/ota";
import {
  ReservationModel,
  SearchRestrictionsModel,
  ReservationRequestModel,
  ReservationAccUnitModel,
  PayByLinkInfoModel,
  ReservationGuestUpdateFeedbackModel,
} from "./types";
import ReservationForm from "./ReservationForm.vue";
import CheckInModalForm from "./check-in/CheckInModalForm.vue";
import CheckOutModalForm, {
  CheckedOutCustomersOnAccUnitType,
} from "./check-out/CheckOutModalForm.vue";
import {
  checkIn,
  checkInToEVisitor,
  loadReservationCustomers,
} from "./check-in/CheckInService";
import ReservationFormInfo from "./ReservationFormInfo.vue";
import FinancialDocumentModalForm from "@/components/finances/FinancialDocumentModalForm.vue";
import { SelectedAvailability } from "@/shared/models/availability";
import { Notification } from "../../store/modules/notifications";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import FinancesTable from "@/components/finances/PagedFinancesTable.vue";
import PaymentsTable from "@/components/finances/PaymentsTable.vue";
import { DateTime } from "luxon";
import { AppParam, AppParamsEnum } from "@/shared/models/appParam";
import { TaxRateView } from "@/shared/models/taxRates";
import { Currency } from "@/shared/models/currency";
import { FinancialSettingsType } from "@/store/modules/financial";
import _ from "lodash";
import { BusinessUnit } from "@/shared/models/businessUnit";
import {
  CheckedInCustomersOnAccUnitType,
  ReservationCheckInCustomerData,
  ServerReservationCheckInCustomerData,
  SetCheckedInCustomers,
} from "./check-in/CheckinTypes";
import EVisitorTable from "@/components/EVisitorTable.vue";
import MessagesTable from "@/components/messages/MessagesTable.vue";
import {
  DistributionChannelEnum,
  FinancialDocumentTypesEnum,
  PaymentGatewayIntegrationEnum,
  ReservationStatusEnum,
  InvoiceStatusEnum,
  EVisitorIntegrationEnum,
  EVisitorIntegrationNameEnum,
  WhatsAppIntegrationStatusEnum,
} from "@/shared/models/enums.type";
import {
  BaseMessageTypeEnum,
  MessageViewModel,
  Recipient,
} from "@/components/messages/types";
import MessageForm from "@/components/messages/MessageForm.vue";
import { AgencyWorkModelsEnum } from "@/shared/models/agencyWorkModel";
import { ServiceType } from "@/shared/models/serviceType";
import { differenceInDays } from "@/shared/dateFormatUtils";
import {
  CurrencyConversionService,
  currencyConversionServiceFactory,
} from "@/shared/currencyConversionService";
import UnitSelectionModal from "./UnitSelectionModal.vue";
import { TenantCustomerModel } from "@/shared/models/tenantCustomer";
import { SalesChannelView } from "@/shared/models/salesChannel";
import CurrencyDisplay from "../misc/CurrencyDisplay.vue";
import NumericInput from "../misc/NumericInput.vue";
import SendPaymentLinkDialog from "./payment-link/SendPaymentLinkDialog.vue";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import InvoiceRoutingModal from "../finances/InvoiceRoutingModal/InvoiceRoutingModal.vue";
import {
  CancellationPolicy,
  GenerateInvoiceResultModel,
  GenerateInvoiceResultModelBulk,
} from "../finances/FinancialDocumentFormParts/models";
import { round } from "@/components/numbers/numberFormatUtils";
import { EVisitorIntegrationModel } from "@/shared/models/eVisitor";
import ColorPicker from "@/components/misc/ColorPicker.vue";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import ReservationLinksModal, {
  ReservationLinksEnum,
} from "@/components/reservation-form/ReservationLinksModal.vue";

export interface GenerateCommissionInvoicesResponse {
  successDocumentIds: number[];
  errorUnitIds: number[];
}

@Component({
  components: {
    ReservationForm,
    ReservationFormInfo,
    FinancesTable,
    PaymentsTable,
    FinancialDocumentModalForm,
    CheckInModalForm,
    CheckOutModalForm,
    EVisitorTable,
    MessagesTable,
    MessageForm,
    UnitSelectionModal,
    CurrencyDisplay,
    SendPaymentLinkDialog,
    NumericInput,
    InvoiceRoutingModal,
    ColorPicker,
    LoadingOverlay,
    ReservationLinksModal,
  },
})
export default class ReservationModal extends Vue {
  @PropSync("open", { default: false }) isOpen?: boolean;
  @Prop({ default: null }) reservationId!: number | null;
  @Prop({ default: null }) scrollId!: string | null;

  @Prop({ default: undefined }) availabilities?: SelectedAvailability[];
  @Prop({ default: undefined }) restrictions?: SearchRestrictionsModel;

  @Prop({ default: false }) fromCalendar?: boolean;

  @Prop({ default: false }) fromPrepaymentDashboard?: boolean;

  @Getter("appParams/tenantWhatsAppIntegrationStatus")
  tenantWhatsAppIntegrationStatus?: WhatsAppIntegrationStatusEnum;

  get tenantWhatsAppIntegrationEnabled() {
    return (
      this.tenantWhatsAppIntegrationStatus ===
      WhatsAppIntegrationStatusEnum.Active
    );
  }

  @Ref("reservationForm") reservationForm?: ReservationForm;

  agencyWorkModelsEnum = AgencyWorkModelsEnum;
  reservationStatusEnum = ReservationStatusEnum;

  isMenuValid = false;
  payByLink = false;
  tenantReservationTags: string[] = [];

  isEvisitorDialogOpen = false;

  reservationLinksModalOpen = false;
  reservationLinksEnum = ReservationLinksEnum;
  get showReservationConfirmationLinkButton() {
    return (
      this.tenantUsesBookingEngineBookingConfirmation &&
      this.reservationModel.statusId === ReservationStatusEnum.Hold
    );
  }

  messagesDirection = 0;
  newMessageFormOpen = false;
  get newMessageRecipients(): Recipient[] {
    if (this.reservationModel.id) {
      const holder = {
        id: this.reservationModel.customer.id,
        type: "Reservation holder",
        name: this.reservationModel.customer.name,
        email: this.reservationModel.customer.eMail,
        telephoneNumber: this.reservationModel.customer.telephoneNumber,
      };

      const guests = this.reservationModel.accomodationUnitTypes.flatMap((x) =>
        x.guests.map((g) => ({
          id: g.id,
          type: "Guest",
          name: g.name,
          email: g.eMail,
          telephoneNumber: g.telephoneNumber,
        }))
      );

      const recipients = [holder, ...guests.filter((g) => !!g.email)];

      this.reservationModel.accomodationUnitTypes.forEach((ut) => {
        const propertyOwner = ut.propertyOwner;
        const unitOwner = ut.unitOwner;
        const propertyManager = ut.propertyManager;

        if (
          propertyOwner &&
          !recipients.some((r) => r.id === propertyOwner.id)
        ) {
          recipients.push({
            id: propertyOwner.id,
            type: "Owner",
            name: propertyOwner.name,
            email: propertyOwner.email,
            telephoneNumber: propertyOwner.telephoneNumber,
          });
        }

        if (unitOwner && !recipients.some((r) => r.id === unitOwner.id)) {
          recipients.push({
            id: unitOwner.id,
            type: "Owner",
            name: unitOwner.name,
            email: unitOwner.email,
            telephoneNumber: unitOwner.telephoneNumber,
          });
        }

        if (
          propertyManager &&
          !recipients.some((r) => r.id === propertyManager.id)
        ) {
          recipients.push({
            id: propertyManager.id,
            type: "Owner",
            name: propertyManager.name,
            email: propertyManager.email,
            telephoneNumber: propertyManager.telephoneNumber,
          });
        }
      });

      return _.uniqBy(recipients, (x) => x.id);
    }

    return [];
  }

  get newMessageType() {
    return BaseMessageTypeEnum.NewMessage;
  }

  get newMessageBase() {
    return {
      reservationId: this.reservationModel.id,
      customerId: this.reservationModel.customerId,
    } as MessageViewModel;
  }

  get showPaymentLinkButton() {
    return (
      this.tenantPaymentGatewayIntegrationId ===
        PaymentGatewayIntegrationEnum.WSPay ||
      this.tenantPaymentGatewayIntegrationId ===
        PaymentGatewayIntegrationEnum.Monri ||
      this.tenantPaymentGatewayIntegrationId ===
        PaymentGatewayIntegrationEnum.NokumoPay
    );
  }

  get isAllowedToReadEVisitor() {
    return policyChecker("READ_EVISITOR")(this.claims);
  }

  get isAllowedToReadFinancialDocuments() {
    return policyChecker("READ_FINANCIAL_DOCUMENTS")(this.claims);
  }

  get isAllowedToReadPayments() {
    return policyChecker("READ_PAYMENTS")(this.claims);
  }

  get isAllowedToReadMessages() {
    return policyChecker("READ_MESSAGES")(this.claims);
  }

  get isOwnerLevel3() {
    return policyChecker("OWNER_LEVEL_3")(this.claims);
  }

  get reservationIsReadonly() {
    if (
      (policyChecker("OWNER_LEVEL_3")(this.claims) &&
        this.reservationModel?.distributionChannelTypeId ===
          DistributionChannelEnum.OwnersReservation) ||
      !policyChecker("OWNER_LEVEL_3")(this.claims)
    ) {
      return false;
    }
    return true;
  }

  get colorPickerStyle() {
    let style = {};
    if (this.reservationModel.colorCodeHex) {
      // style = {
      //   ...style,
      //   "box-shadow": `${this.reservationModel.colorCodeHex} 44px 0px 0px 0px inset, #ffffffff 46px 0px 0px 0px inset`,
      // };
      style = {
        ...style,
        "background-color": `${this.reservationModel.colorCodeHex}`,
        "border-right": `#ffffffff 2px solid`,
      };
    }
    return style;
  }

  @Ref("messagesTable") messagesTable?: MessagesTable;
  refreshMessagesTable() {
    this.messagesTable?.load();
  }

  closeModal() {
    if (!this.isSaving) {
      this.$emit("reload");
      this.isOpen = false;
    }
  }

  openWhatsAppConversation() {
    const phoneNumber = this.reservationModel.customer.telephoneNumber;

    if (!phoneNumber) {
      return;
    }

    this.messagesTable?.openWhatsAppConversation(
      this.reservationModel.customer.id,
      this.reservationModel.customer.name,
      phoneNumber
    );
  }

  currencyConversionService?: CurrencyConversionService;
  async created() {
    const promises = [];

    if (!this.financialSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    if ((this.otas?.length ?? 0) === 0 && this.refreshOtas) {
      promises.push(this.refreshOtas());
    }

    if ((this.appParams?.length ?? 0) === 0 && this.refreshAppParams) {
      promises.push(this.refreshAppParams());
    }

    if ((this.serviceTypes?.length ?? 0) === 0 && this.refreshServiceTypes) {
      promises.push(this.refreshServiceTypes());
    }

    if ((this.salesChannels?.length ?? 0) === 0 && this.refreshSalesChannels) {
      promises.push(this.refreshSalesChannels());
    }

    await Promise.all(promises);

    if (this.financialSettings) {
      this.currencyConversionService = currencyConversionServiceFactory(
        this.financialSettings
      );
    }
  }

  get period() {
    if (
      this.localRestrictions &&
      this.localRestrictions.period &&
      this.localRestrictions.period.length == 2
    ) {
      return this.localRestrictions.period;
    }

    if (this.reservationPeriod && this.reservationPeriod.length == 2) {
      return this.reservationPeriod;
    }

    return null;
  }

  get otaName() {
    const otaName = this.otas?.find(
      (x) => x.id == this.reservationModel?.otaid
    )?.name;
    return otaName ?? "";
  }

  get salesChannelName() {
    const salesChannel = this.salesChannels?.find(
      (x) => x.id == this.reservationModel?.salesChannelId
    )?.name;
    return salesChannel ?? "";
  }

  @Watch("isLoading")
  isLoadingChanged() {
    if (this.isLoading === false && this.scrolledFlag === false) {
      this.$nextTick(() => {
        const elem = document.getElementById(this.scrollId ?? "");
        if (elem) {
          elem.scrollIntoView({
            behavior: "auto",
          });
          this.scrolledFlag = true;
        }
      });
    }
  }

  isOverbooked: number[] = [];

  isNotAvailable: number[] = [];

  tab = 0;
  fkey = 0;

  localAvailabilities?: SelectedAvailability[] = [];
  localRestrictions?: SearchRestrictionsModel | null = null;

  reservationModel: ReservationModel = new ReservationModel();
  reservationPeriod: Date[] | null = null;

  // when updating a reservation and changing arrival or departure date, the new stay period might not cover all days of the original one
  // which causes the calendar to be only partially updated. those original dates are preserved here to make sure the calendar is properly updated
  historicArrivalDate: Date | null = null;
  historicDepartureDate: Date | null = null;

  menu = false;

  changedOtaReservationId = "";

  menuOpen = false;

  isLoading = false;
  isSaving = false;
  get isLoadingOrSaving() {
    return this.isLoading || this.isSaving;
  }

  get hasAccomodationUnitTypes() {
    return (this.reservationModel?.accomodationUnitTypes?.length ?? 0) > 0;
  }

  checkInSingleUnit(event: number) {
    this.openCheckIn(true, event);
  }
  checkOutSingleUnit(event: number) {
    this.openCheckOut(event);
  }
  tagsChanged(event: string[]) {
    this.reservationModel.tags = event;
  }

  singleUnit: number | null = null;
  isCheckInOpen = false;
  isCheckInLoading = false;
  checkedInCustomersOnAccUnitTypes = [] as CheckedInCustomersOnAccUnitType[];
  async openCheckIn(
    padWithEmptyCards = true,
    singleUnitId: null | number = null
  ) {
    if (!this.hasAccomodationUnitTypes) {
      return;
    }

    this.singleUnit = singleUnitId;

    const instance = loadReservationCustomers(this.axios);

    this.isLoading = true;

    try {
      const data = await instance(this.reservationModel.id);

      const result = [] as CheckedInCustomersOnAccUnitType[];

      const unitTypes = this.reservationModel.accomodationUnitTypes.filter(
        (x) => {
          if (!singleUnitId) {
            return x.statusId != ReservationStatusEnum.NoShow;
          }

          return (
            x.accomodationUnitId == singleUnitId &&
            x.statusId != ReservationStatusEnum.NoShow
          );
        }
      );

      for (const aut of unitTypes) {
        const allocated = aut.numberOfAdults + aut.numberOfChildren;

        let group = data.payload.find(
          (x) => x.reservationAccUnitTypeId === aut.id
        );
        if (!group) {
          group = new CheckedInCustomersOnAccUnitType();

          group.reservationAccUnitTypeId = aut.id;
          group.reservationAccUnitTypeCheckOutDate = aut.departureDate ?? null;
          group.reservationAccUnitTypeCheckOutTime =
            aut.expectedDepartureTime ?? null;
          group.guests = [];
        }

        group.reservationAccUnitTypeAllocated = allocated;
        group.propertyId = aut.propertyId ?? null;
        group.propertyName = aut.propertyName;
        group.propertyCheckOutTime = aut.checkOutTimeUntil;
        group.accomodationUnitTypeName = aut.accomodationUnitTypeName;
        group.accomodationUnitName = aut.accomodationUnitName;
        group.accomodationUnitId = aut.accomodationUnitId ?? null;
        group.reservationAccUnitTypeAllocatedMax = aut.maxOccupancy;

        data.payload.push();

        if (padWithEmptyCards) {
          const missingAllcoated = allocated - group.guests.length;
          if (missingAllcoated > 0) {
            const empty = [...Array(missingAllcoated)].map((_, i) => {
              const g = new ReservationCheckInCustomerData();
              g.id = -i;
              return g;
            });
            group.guests.push(...empty);
          }
        }

        if (this.guestEVisitorStatuses.length > 0) {
          this.guestEVisitorStatuses.forEach((x) => {
            const guest = group?.guests.find((g) => g.id == x.id);
            if (guest) {
              guest.eVisitorCheckinResult = x.status;
            }
          });
        }

        group.isDayStay = aut.arrivalDate == aut.departureDate;

        result.push(group);
      }

      this.checkedInCustomersOnAccUnitTypes = result;
      this.guestEVisitorStatuses = [];
    } finally {
      this.isLoading = false;
    }

    this.isCheckInOpen = true;
  }

  get currencyId() {
    const ids =
      this.reservationModel?.accomodationUnitTypes
        .map((x) => x.ratePlan?.currencyId)
        .filter((x) => x != undefined) ?? [];
    if (ids.length > 0) {
      return ids[0];
    }

    return this.financialSettings?.workingCurrency.id;
  }

  get currencyIsoCode() {
    const currency = this.currencies?.find((x) => x.id == this.currencyId);
    return (
      currency?.isoCode ??
      this.financialSettings?.workingCurrency.isoCode ??
      "EUR"
    );
  }
  get workingCurrency() {
    return this.financialSettings?.workingCurrency.id;
  }

  payByLinkResult = new PayByLinkInfoModel();

  async openPayByLink() {
    this.isLoading = true;
    await Vue.axios
      .post<PayByLinkInfoModel>("reservations/GetReservationInfoForPayByLink", {
        reservationId: this.reservationModel.id,
      })
      .then((res) => {
        this.payByLinkResult = res.data;
      });
    this.payByLink = true;
    this.isLoading = false;
  }

  @Watch("payByLink")
  payByLinkOpenWatch(fresh: boolean, old: boolean) {
    // refresh the payments table when closing the direct charge modal
    if (!fresh && old) {
      this.paymentsTableRef?.load();
    }
  }

  async checkInReservationUpdate(guestIds: number[]) {
    try {
      await Vue.axios.post(
        `reservations/ReservationUpdateForMultipleGuestIds`,
        {
          guestIds: guestIds,
        }
      );
    } finally {
      this.isLoading = false;
    }
  }

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegrationGetter?: EVisitorIntegrationModel;

  get eVisitorIntegration() {
    return (
      this.eVisitorIntegrationGetter ??
      ({
        id: EVisitorIntegrationEnum.None,
        name: EVisitorIntegrationNameEnum.None,
      } as EVisitorIntegrationModel)
    );
  }

  @Ref("eVisitorTable") eVisitorTableRef?: EVisitorTable;

  guestEVisitorStatuses: any[] = [];

  async checkInModalSaved(evt: {
    sendData: SetCheckedInCustomers;
    checkInToEVisitor: boolean;
    singleUnitId: number | null;
  }) {
    this.isCheckInLoading = true;

    try {
      await checkIn(this.axios)(evt);
      await this.openCheckIn(false, evt.singleUnitId);
      if (evt.checkInToEVisitor) {
        let guests = [] as ReservationCheckInCustomerData[];

        if (
          this.checkedInCustomersOnAccUnitTypes?.some((x) => x.isDayStay) &&
          this.checkedInCustomersOnAccUnitTypes?.some((x) => !x.isDayStay)
        ) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message: this.$t("EVisitor.DayStaysWillNotBeCheckedIn", {
              eVisitorServiceName: this.eVisitorIntegration.name,
            }),
            timeout: 30000,
            localize: false,
          } as Notification);

          guests =
            this.checkedInCustomersOnAccUnitTypes
              ?.filter((x) => !x.isDayStay)
              .flatMap((x) => x.guests) ?? [];
        } else {
          guests =
            this.checkedInCustomersOnAccUnitTypes.flatMap((x) => x.guests) ??
            [];
        }

        const allSucceded = await checkInToEVisitor(this)(
          guests,
          this.eVisitorIntegration
        );

        if (allSucceded) {
          this.guestEVisitorStatuses = [];
          this.isCheckInOpen = false;
        } else {
          guests.forEach((x) => {
            this.guestEVisitorStatuses.push({
              id: x.id,
              status: x.eVisitorCheckinResult,
            });
          });

          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t("EVisitor.CheckIn.SomeErrors", {
              eVisitorServiceName: this.eVisitorIntegration.name,
            }),
            timeout: 5000,
            localize: false,
          } as Notification);
        }

        this.eVisitorTableRef?.load();
      } else {
        this.guestEVisitorStatuses = [];
        this.isCheckInOpen = false;
      }

      this.isLoading = true;
      await this.checkInReservationUpdate(
        this.checkedInCustomersOnAccUnitTypes
          ?.flatMap((x) => x.guests)
          .map((x) => x.id)
      );
      await this.loadReservation(this.reservationModel.id);
    } finally {
      this.isCheckInLoading = false;
      this.calendarReload();
    }
  }

  isCheckOutOpen = false;
  checkOutCustomersOnAccUnitTypes = [] as CheckedOutCustomersOnAccUnitType[];
  get canCheckOutGuests() {
    return (
      !!this.reservationModel.id &&
      (this.reservationModel.accomodationUnitTypes.some(
        (x) => x.statusId === ReservationStatusEnum.CheckedIn
      ) ||
        this.reservationModel.statusId === ReservationStatusEnum.CheckedIn)
    );
  }
  async openCheckOut(singleUnitId: null | number = null) {
    if (!this.hasAccomodationUnitTypes) {
      return;
    }

    this.singleUnit = singleUnitId;

    const instance = loadReservationCustomers(this.axios);

    this.isLoading = true;

    try {
      const data = await instance(this.reservationModel.id);

      const result = [] as CheckedOutCustomersOnAccUnitType[];

      const nowDate = DateTime.local().toISODate().substr(0, 10);
      const nowTime = DateTime.local().toISOTime().substr(0, 5);

      const unitTypes = this.reservationModel.accomodationUnitTypes.filter(
        (x) => {
          if (!singleUnitId) {
            return x.statusId != ReservationStatusEnum.NoShow;
          }
          return (
            x.accomodationUnitId == singleUnitId &&
            x.statusId != ReservationStatusEnum.NoShow
          );
        }
      );

      for (const aut of unitTypes) {
        const unitDisplayFull = `${aut.propertyName}, ${aut.accomodationUnitTypeName}, ${aut.accomodationUnitName}`;

        for (const g of data.payload
          .filter((p) => p.reservationAccUnitTypeId === aut.id)
          .flatMap((x) => x.guests)) {
          const newGuest = {
            ...new ServerReservationCheckInCustomerData(),
            ...g,
            checked: true,
            unitDisplayFull: unitDisplayFull,
            reservationAccUnitTypeId: aut.id,
            isDayStay: aut.arrivalDate == aut.departureDate,
          };

          if (
            !newGuest.eVisitorCheckoutDate ||
            newGuest.eVisitorCheckoutDate === ""
          ) {
            newGuest.eVisitorCheckoutDate = newGuest.checkOutDate = nowDate;
          }
          if (
            !newGuest.eVisitorCheckoutTime ||
            newGuest.eVisitorCheckoutTime === ""
          ) {
            newGuest.eVisitorCheckoutTime = nowTime;
          }

          result.push(newGuest);
        }
      }

      this.checkOutCustomersOnAccUnitTypes = result;
    } finally {
      this.isLoading = false;
    }

    this.isCheckOutOpen = true;
  }

  async checkOutModalSaved() {
    if (this.reservationModel?.id) {
      this.loadReservation(this.reservationModel.id);
      this.eVisitorTableRef?.load();
      this.calendarReload();
    }
  }

  async checkOutModalFailed() {
    if (this.reservationModel?.id) {
      this.loadReservation(this.reservationModel.id);
      this.openCheckOut();
      this.calendarReload();
    }
  }

  async getReservationTags() {
    const promises = [];

    promises.push(
      Vue.axios.get<any[]>(`reservations/GetTenantReservationTags`)
    );

    const [tags] = await Promise.all(promises);

    this.tenantReservationTags = tags.data;
  }

  @Watch("isOpen")
  async isOpenWatch(fresh: boolean) {
    this.internalForm?.resetValidation();

    if (fresh && this.reservationId) {
      this.scrolledFlag = false;
      await this.loadReservation(this.reservationId);
      await this.getReservationTags();
    } else if (fresh) {
      this.formStateUnchanged = false;
      this.setGuestsUnchanged && this.setGuestsUnchanged(false);
      await this.getReservationTags();

      if (this.reservationModel) {
        const initialStateParam = this.appParams?.find(
          (x) => x.id == AppParamsEnum.ReservationInitialState
        );
        if (initialStateParam) {
          this.reservationModel.statusId = initialStateParam.value;
        }

        this.reservationModel.arrivalDate =
          this.restrictions?.period?.[0] ?? null;
        this.reservationModel.departureDate =
          this.restrictions?.period?.[1] ?? null;

        const holdDurationParam = this.appParams?.find(
          (x) => x.id == AppParamsEnum.ReservationDefaultHoldDuration
        );
        if (holdDurationParam) {
          const optionExpirationDate = new Date();
          optionExpirationDate.setDate(
            optionExpirationDate.getDate() + holdDurationParam.value
          );
          this.reservationModel.optionExpirationDate = optionExpirationDate
            .toISOString()
            .substr(0, 10);
        }
        if (policyChecker("OWNER_LEVEL_3")(this.claims)) {
          this.reservationModel.statusId = ReservationStatusEnum.Confirmed;
          this.reservationModel.distributionChannelTypeId =
            DistributionChannelEnum.OwnersReservation;
        }
      }

      // ! if this is moved before section handling this.reservationModel
      // ! stuff may break ... yeah ...
      this.localRestrictions = this.restrictions;
      this.localAvailabilities = this.availabilities;
    } else {
      this.tab = 0;
      this.reservationModel = new ReservationModel();
      this.reservationPeriod = null;
      this.localAvailabilities = [];
      this.localRestrictions = null;
      this.formStateUnchanged = false;
      this.historicArrivalDate = null;
      this.historicDepartureDate = null;
      if (this.reservationForm) {
        this.reservationForm.stayPeriodFromUnits = null;
      }
    }
  }

  get lineItemAffecting() {
    if (!this.reservationModel) return [];

    return this.reservationModel.accomodationUnitTypes
      .map((x) => ({
        accomodationUnitId: x.accomodationUnitId ?? 0,
        pricePerNight: x.pricePerNight ?? 0,
        userSetPricePerNightManually: x.userSetPricePerNightManually,
        discountPercent: x.discountPercent ?? 0,
        deposit: x.damageDeposit ?? 0,
        depositCurrency: x.depositCurrencyId ?? 0,
        selectedServices: [...x.selectedServices].sort(
          (a, b) => a.addOnServiceId - b.addOnServiceId
        ),
      }))
      .sort((a, b) => a.accomodationUnitId - b.accomodationUnitId);
  }

  @Watch("lineItemAffecting", { deep: true })
  lineItemAffectingChanged(
    fresh: (typeof ReservationModal.prototype.lineItemAffecting)[],
    old: (typeof ReservationModal.prototype.lineItemAffecting)[]
  ) {
    if (this.isLoading) return;

    if (!_.isEqual(fresh, old)) {
      this.formStateUnchanged = false;
    }
  }

  formStateUnchanged = false;
  originalUnits = [] as ReservationAccUnitModel[];

  noOverbookingMessage = false;

  noNotAvailableMessage = false;

  @Watch("isOverbooked")
  isOverbookedChanged() {
    if (!_.isEmpty(this.isOverbooked) && !this.noOverbookingMessage) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: "Reservation.Overbooked",
        timeout: 5000,
        localize: true,
      } as Notification);
    }
    this.noOverbookingMessage = false;
  }

  @Watch("isNotAvailable")
  isNotAvailableChanged() {
    if (!_.isEmpty(this.isNotAvailable) && !this.noNotAvailableMessage) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: "Reservation.NotAllUnitTypesAvailable",
        timeout: 5000,
        localize: true,
      } as Notification);
    }
    this.noNotAvailableMessage = false;
  }

  @Ref("financestable") financialTableRef?: { load: () => Promise<any> };
  @Ref("paymentstable") paymentsTableRef?: { load: () => Promise<any> };
  async loadReservation(reservationId: number) {
    this.isLoading = true;
    await Vue.axios
      .get<ReservationModel>("reservations/" + reservationId)
      .then((res) => {
        const fresh = {
          ...new ReservationModel(),
          ...res.data,
          originalUnitTypesReservationWasOpenedWith: _.cloneDeep(
            res.data.accomodationUnitTypes
          ),
        };

        if (fresh.arrivalDate && fresh.departureDate) {
          this.reservationPeriod = [];
          const tempArrival = new Date(fresh.arrivalDate);
          const tempDeparture = new Date(fresh.departureDate);
          const arrival = new Date(
            Date.UTC(
              tempArrival.getFullYear(),
              tempArrival.getMonth(),
              tempArrival.getDate()
            )
          );
          const departure = new Date(
            Date.UTC(
              tempDeparture.getFullYear(),
              tempDeparture.getMonth(),
              tempDeparture.getDate()
            )
          );

          fresh.arrivalDate = arrival;
          fresh.departureDate = departure;

          this.reservationPeriod.push(arrival, departure);

          if (
            this.reservationForm &&
            this.reservationForm.stayPeriodFromUnits
          ) {
            this.reservationForm.stayPeriodFromUnits = null;
          }

          this.historicArrivalDate = arrival;
          this.historicDepartureDate = departure;
        } else {
          // so this seems to have relied on grandchild's watch
          // or it would break, it's insane way of programming
          fresh.arrivalDate = null;
          fresh.departureDate = null;
        }

        this.localRestrictions = null;

        for (const unit of fresh.accomodationUnitTypes) {
          unit.dayPrices.forEach((x) => {
            x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay(unit);
          });
          if (!unit.userSetPricePerNightManually) {
            unit.pricePerNight = round(
              round(
                unit.dayPrices.reduce((sum, dprice) => sum + dprice.price, 0) ??
                  0
              ) / (unit.dayPrices.length ?? 1)
            );
          }

          unit.currentDayPrices = unit.dayPrices.map((x) => {
            return {
              date: x.date,
              price: x.price,
              ratePlanAccomodationUnitTypeId:
                unit.ratePlan?.ratePlansAccomodationUnitTypeId || 0,
              occupancyBasedRuleId: unit.occupancyBasedRuleId,
            };
          });
        }

        fresh.accomodationUnitTypes
          .filter((x) => !x.userSetPricePerNightManually)
          .forEach(
            (x) =>
              (x.pricePerNight = round(
                round(
                  x.dayPrices.reduce(
                    (sum, dprice) =>
                      sum + dprice.price + this.mergedCityTaxPricePerDay(x),
                    0
                  ) ?? 0
                ) / (x.dayPrices.length ?? 1)
              ))
          );

        this.reservationModel = fresh;
        this.formStateUnchanged = true;

        this.originalUnits = _.cloneDeep(
          this.reservationModel.accomodationUnitTypes
        );

        this.reservationModel.accomodationUnitTypes;

        this.financialTableRef?.load();
      })
      .finally(() => {
        this.isLoading = false;
      });

    this.setGuestsUnchanged && this.setGuestsUnchanged(true);

    if (this.isCheckInOpen) {
      await this.openCheckIn(false, this.singleUnit);
    }
    this.changedOtaReservationId = this.reservationModel.otareservationId;
  }

  mergedCityTaxPricePerDay(unit: ReservationAccUnitModel) {
    const currencyId =
      unit.ratePlan?.currencyId ?? this.financialSettings?.workingCurrency.id;
    let totalCityTaxPrice = 0;
    if (unit && unit.selectedServices) {
      totalCityTaxPrice = unit.selectedServices
        .filter((x) => x.isCityTax)
        .reduce(
          (sum, e) =>
            this.serviceTypes?.find(
              (x) => x.id == _.first(unit.dayPrices)?.serviceTypeId
            )?.includesCityTax === true
              ? sum +
                (this.currencyConversionService?.convertCurrency(
                  e.grossPrice,
                  e.currencyId,
                  currencyId ?? e.currencyId
                ) ?? e.grossPrice)
              : sum,
          0
        );
    }

    return (
      totalCityTaxPrice /
      (this.numberOfNights(unit) > 0 ? this.numberOfNights(unit) : 1)
    );
  }

  numberOfNights(unit: ReservationAccUnitModel) {
    if (unit.arrivalDate && unit.departureDate) {
      return differenceInDays(
        new Date(unit.arrivalDate),
        new Date(unit.departureDate)
      );
    } else {
      return 0;
    }
  }

  formValid = false;

  @Ref("form") internalForm?: {
    reset: () => void;
    resetValidation: () => void;
    validate: () => boolean;
  };

  isReservationValid() {
    if (!this.reservationModel) {
      return false;
    }

    if (!this.reservationModel.customerId) {
      return false;
    }

    if (!this.reservationModel.distributionChannelTypeId) {
      return false;
    }

    if (
      !this.reservationModel.arrivalDate ||
      !this.reservationModel.departureDate
    ) {
      return false;
    }

    if ((this.reservationModel.accomodationUnitTypes?.length ?? 0) == 0) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: "Reservation.NoUnitsSelected",
        timeout: 5000,
        localize: true,
      } as Notification);
      return false;
    }
    // all units must have a rate plan selected
    if (
      this.reservationModel.accomodationUnitTypes.some((x) => !x.ratePlan?.id)
    ) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: "Reservation.AllUnitsMustHaveRatePlan",
        timeout: 5000,
        localize: true,
      } as Notification);
      return false;
    }
    // all children ages must be set
    if (
      this.reservationModel.accomodationUnitTypes.some((x) =>
        x.childrenAges.some(
          (ca) => ca == null || ca == undefined || ca.toString() == "" || ca < 0
        )
      )
    ) {
      return false;
    }

    if (
      this.reservationModel.numberOfUnits &&
      this.reservationModel.numberOfUnits <
        this.reservationModel.accomodationUnitTypes.length
    ) {
      return false;
    }

    if (
      this.reservationModel.accomodationUnitTypes.some(
        (x) => !x.dayPrices || x.dayPrices.length === 0
      )
    ) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: "Reservation.AllUnitsMustHaveDayPrices",
        timeout: 5000,
        localize: true,
      } as Notification);
      return false;
    }

    return true;
  }

  submit(
    overrides: string[],
    updateStayOnEvisitor: boolean,
    updateCheckedOutOnEvisitor: boolean
  ) {
    this.isSaving = true;
    this.noOverbookingMessage = true;
    this.noNotAvailableMessage = true;

    const formValid = this.internalForm?.validate();

    if (!formValid || !this.isReservationValid()) {
      //check numberOfUnits on ReservationModel
      if (
        this.reservationModel.numberOfUnits &&
        this.reservationModel.numberOfUnits <
          this.reservationModel.accomodationUnitTypes.length
      ) {
        this.$store.dispatch("showNotification", {
          color: "warning",
          message: this.$t("Reservation.ToManyUnitsSelected"),
          timeout: 5000,
          actions: [
            {
              text: this.$t("Yes"),
              fun: () => {
                //Save reservation
                this.saveReservation(
                  overrides,
                  updateStayOnEvisitor,
                  updateCheckedOutOnEvisitor
                );
                return true;
              },
            },
            {
              text: this.$t("Cancel"),
              fun: () => {
                return false;
              },
            },
          ],
        } as Notification);
      }
      this.isSaving = false;
      return;
    } else if (formValid && this.isReservationValid()) {
      this.saveReservation(
        overrides,
        updateStayOnEvisitor,
        updateCheckedOutOnEvisitor
      );
    }
  }

  isFunction(x: any) {
    return Object.prototype.toString.call(x) === "[object Function]";
  }

  saveReservation(
    overrides: string[],
    updateStayOnEvisitor: boolean,
    updateCheckedOutOnEvisitor: boolean
  ) {
    const requestModel = new ReservationRequestModel(this.reservationModel);
    let guestUpdateResult = new ReservationGuestUpdateFeedbackModel();

    // set 'hasChanges = false' if there's no changes between the unit that was loaded and the unit being saved
    requestModel.accomodationUnitTypes
      .filter((x) => x.id != 0)
      .forEach((x) => {
        const original = _.cloneDeep(
          this.originalUnits.find((e) => e.id === x.id)
        );
        const fresh = _.cloneDeep(
          this.reservationModel.accomodationUnitTypes.find((e) => e.id === x.id)
        );

        // original sometimes doesn't have the 'serviceTypeId' at all which is detected as a difference
        original?.dayPrices.forEach((dp) => {
          if (dp.serviceTypeId === undefined) {
            dp.serviceTypeId = undefined;
          }
        });

        // format dates
        original?.selectedServices.forEach((x) => {
          if (x.serviceDateFrom) {
            x.serviceDateFrom = x.serviceDateFrom.substring(0, 10);
          }
          if (x.serviceDateTo) {
            x.serviceDateTo = x.serviceDateTo.substring(0, 10);
          }
        });

        fresh?.selectedServices.forEach((x) => {
          if (x.serviceDateFrom) {
            x.serviceDateFrom = x.serviceDateFrom.substring(0, 10);
          }
          if (x.serviceDateTo) {
            x.serviceDateTo = x.serviceDateTo.substring(0, 10);
          }

          // remove properties not needed for comparison (ids, serviceRange)
          delete (x as any).idx;
          delete (x as any).serviceRange;
        });

        // find differences, ignoring functions and certain properties
        const diff = {};
        for (const key in original) {
          if (
            this.isFunction((original as any)[key as string]) ||
            key === "ratePlanOptions" ||
            key === "accomodationUnitOptions" ||
            key === "availableServices"
          ) {
            continue;
          }

          if (!_.isEqual((original as any)[key], (fresh as any)[key])) {
            (diff as any)[key] = {
              o: (original as any)[key],
              f: (fresh as any)[key],
            };
          }
        }

        for (const key in fresh) {
          if (
            this.isFunction((fresh as any)[key as string]) ||
            key === "ratePlanOptions" ||
            key === "accomodationUnitOptions" ||
            key === "availableServices"
          ) {
            continue;
          }

          if (
            !_.isEqual((original as any)[key], (fresh as any)[key]) &&
            !(diff as any)[key]
          ) {
            (diff as any)[key] = {
              o: (original as any)[key],
              f: (fresh as any)[key],
            };
          }
        }

        x.hasChanges = Object.getOwnPropertyNames(diff).length > 0;
      });

    const handleCodes = [
      "Reservation.NotAllUnitTypesAvailable",
      "Reservation.Overbooked",
    ];
    const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

    // prettier-ignore
    const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

    const isOverriding = overrides.length !== 0;

    if (requestModel.id) {
      Vue.axios
        .put(
          "reservations/" + requestModel.id,
          {
            ...requestModel,
            overrideRules: overrides,
            updateStayOnEvisitor: updateStayOnEvisitor,
            updateCheckedOutOnEvisitor: updateCheckedOutOnEvisitor,
          },
          {
            adapter: isOverriding ? undefined : adapter,
          }
        )
        .then((res) => {
          guestUpdateResult = res.data;
          this.$emit("reservationUpdated");
          this.loadReservation(requestModel.id);
          this.calendarReload();
          this.$store.dispatch("showNotification", {
            color: "success",
            message: "Reservation.SaveSuccess",
            timeout: 5000,
            localize: true,
          } as Notification);
          if (updateStayOnEvisitor === true && guestUpdateResult.isSuccessful) {
            this.$store.dispatch("showNotification", {
              color: "success",
              message: this.$t("EVisitor.SaveSuccess", {
                eVisitorServiceName: this.eVisitorIntegration.name,
              }),
              timeout: 5000,
            });
          } else if (
            updateStayOnEvisitor === true &&
            !guestUpdateResult.isSuccessful
          ) {
            // This is done in a loop to show each guest error separately. It is much more visible this way instead of one notification
            guestUpdateResult.guestsWithErrors.forEach((guest) => {
              const message = `${guest.guestName} - ${guest.errorMessage}`;
              this.$store.dispatch("showNotification", {
                color: "error",
                message:
                  this.$t("Guest check-in on eVisitor failed", {
                    eVisitorServiceName: this.eVisitorIntegration.name,
                  }) + message,
                timeout: 10000,
              });
            });
          }
        })
        .catch((x) => {
          if (x && x.isHandleBrokenRuleResult && !isOverriding) {
            this.$store.dispatch("showNotification", {
              color: "warning",
              message:
                // prettier-ignore
                `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
              timeout: 30000,
              actions: [
                {
                  text: this.$t("Yes"),
                  fun: () => {
                    this.submit(
                      x.handled,
                      updateStayOnEvisitor,
                      updateCheckedOutOnEvisitor
                    );
                    return true;
                  },
                },
                { text: this.$t("Cancel"), fun: () => true },
              ],
            } as Notification);
          } else {
            if (x.unhandled) {
              if (
                x.unhandled.some(
                  (br: string) => br === "ReservationUpdate.ChangedError"
                )
              ) {
                this.$store.dispatch("showNotification", {
                  color: "error",
                  message: `${formatBrokenRuleNames(x.unhandled)}`,
                  timeout: 5000,
                  actions: [
                    {
                      text: this.$t("Reload reservation"),
                      fun: () => {
                        this.$emit("reservationUpdated");
                        this.loadReservation(requestModel.id);
                        this.calendarReload();
                        return true;
                      },
                    },
                  ],
                  localize: true,
                } as Notification);
              } else {
                this.$store.dispatch("showNotification", {
                  color: "error",
                  message: `${formatBrokenRuleNames(x.unhandled)}`,
                  timeout: 5000,
                  localize: true,
                } as Notification);
              }
            }
          }
          this.noOverbookingMessage = false;
        })
        .finally(() => {
          this.isSaving = false;
          this.eVisitorTableRef?.refresh();
        });
    } else {
      Vue.axios
        .post<number>(
          "reservations",
          {
            ...requestModel,
            overrideRules: overrides,
          },
          {
            adapter: isOverriding ? undefined : adapter,
          }
        )
        .then((res) => {
          this.reservationModel.id = res.data;
          this.calendarReload();

          this.$store.dispatch("showNotification", {
            color: "success",
            message: "Reservation.SaveSuccess",
            timeout: 5000,
            localize: true,
          } as Notification);

          this.loadReservation(this.reservationModel.id);
        })
        .catch((x) => {
          if (x && x.isHandleBrokenRuleResult && !isOverriding) {
            this.$store.dispatch("showNotification", {
              color: "warning",
              message:
                // prettier-ignore
                `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
              timeout: 30000,
              actions: [
                {
                  text: this.$t("Yes"),
                  fun: () => {
                    this.submit(
                      x.handled,
                      updateStayOnEvisitor,
                      updateCheckedOutOnEvisitor
                    );
                    return true;
                  },
                },
                { text: this.$t("Cancel"), fun: () => true },
              ],
            } as Notification);
          } else {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: `${formatBrokenRuleNames(x.unhandled)}`,
              timeout: 5000,
              localize: true,
            } as Notification);
          }
          this.noOverbookingMessage = false;
          this.noNotAvailableMessage = false;
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  }

  markReservationStatusAsOverriden = false;

  confirmEvisitorStayUpdate(
    updateCheckedIn: boolean,
    updateCheckedOut: boolean
  ) {
    this.submit([], updateCheckedIn, updateCheckedOut);
    this.isEvisitorDialogOpen = false;
  }

  get beautifiedEvisitorText() {
    const text = this.$t("Reservation.UpdateEvisitorStayDates.Info", {
      eVisitorServiceName: this.eVisitorIntegration.name,
    }) as string;

    return text
      .replace(/\? /g, "?<br><br>")
      .replace(/\. /g, ".<br><br>")
      .split("\n")
      .map((line) => `<span>${line.trim()}</span>`)
      .join("<br>");
  }

  get shouldUpdateOnEvisitor() {
    return (
      (this.historicArrivalDate?.toDateString() !==
        this.reservationModel.arrivalDate?.toDateString() ||
        this.historicDepartureDate?.toDateString() !==
          this.reservationModel.departureDate?.toDateString()) &&
      this.reservationModel.accomodationUnitTypes
        .flatMap((x) => x.guests)
        .some((g) => g.isEVisitorCheckedIn === true)
    );
  }

  paymentSaved() {
    this.financialTableRef?.load();
    this.paymentsTableRef?.load();
    this.loadReservation(this.reservationModel.id);
  }

  get areAllSameProperty() {
    const propertyIds = this.reservationModel.accomodationUnitTypes.map(
      (x) => x.propertyId
    );
    return (
      propertyIds.length === 0 || propertyIds.every((x) => x === propertyIds[0])
    );
  }

  get areAllSameOwner() {
    const ownerIds = this.reservationModel.accomodationUnitTypes.map(
      (x) => x.ownerId
    );

    return ownerIds.length === 0 || ownerIds.every((x) => x === ownerIds[0]);
  }

  get areAllSameAgencyWorkModel() {
    const workModelIds = this.reservationModel.accomodationUnitTypes.map(
      (x) => x.agencyWorkModelId
    );

    return (
      workModelIds.length === 0 ||
      workModelIds.every((x) => x === workModelIds[0])
    );
  }

  get areAllInOtherNameAndOtherInvoiceSameOwner() {
    const ownerIds = this.reservationModel.accomodationUnitTypes
      .filter(
        (x) =>
          x.agencyWorkModelId === AgencyWorkModelsEnum.OtherNameAndOtherInvoice
      )
      .map((x) => x.ownerId);

    return ownerIds.length === 0 || ownerIds.every((x) => x === ownerIds[0]);
  }

  //'u svoje ime i za tuđi račun'
  get areAllInOwnNameAndOtherInvoice() {
    const workModelIds = this.reservationModel.accomodationUnitTypes.map(
      (x) => x.agencyWorkModelId
    );

    return (
      workModelIds.length === 0 ||
      workModelIds.every(
        (x) => x === AgencyWorkModelsEnum.OwnNameAndOtherInvoice
      )
    );
  }

  get areAllSameVATCategoryForPrepayments() {
    const vats = this.reservationModel.accomodationUnitTypes.map(
      (x) => x.vatCategoryForPrepayments
    );
    return vats.length === 0 || vats.every((x) => x === vats[0]);
  }

  shouldRouteDocumentsForDifferentOwners(
    documentTypeId: FinancialDocumentTypesEnum
  ) {
    const differentModelOrTaxCategory =
      !this.areAllSameVATCategoryForPrepayments ||
      !this.areAllInOwnNameAndOtherInvoice;
    if (differentModelOrTaxCategory) return true;

    if (documentTypeId === FinancialDocumentTypesEnum.RacunZaPredujam)
      return this.routePrepaymentsForOwnNameAndOtherInvoice;
    if (documentTypeId === FinancialDocumentTypesEnum.Racun)
      return this.routeInvoicesForOwnNameAndOtherInvoice;
  }

  get showOtaReservationId() {
    return (
      !this.isOwnerLevel3 &&
      ((this.reservationModel.distributionChannelTypeId ==
        DistributionChannelEnum.OTA &&
        this.reservationModel.otareservationId) ||
        (this.reservationModel.distributionChannelTypeId ==
          DistributionChannelEnum.PartnerAgency &&
          this.reservationModel.salesChannelId))
    );
  }

  get isPartnerAgency() {
    return (
      this.reservationModel.distributionChannelTypeId ==
        DistributionChannelEnum.PartnerAgency &&
      this.reservationModel.salesChannelId
    );
  }

  reloadFinancialTable() {
    this.financialTableRef?.load();
  }

  cancellationConfirmDialog = false;

  async checkCancellationPolicies() {
    await this.axios
      .get<CancellationPolicy[]>(
        "/reservations/GetEffectiveCancellationPolicies",
        {
          params: { reservationId: this.reservationModel.id },
        }
      )
      .then((res) => {
        const amount = _.reduce(
          res.data,
          (sum, el) => {
            return (sum += el.amount);
          },
          0
        );

        if (amount === 0) {
          this.cancellationConfirmDialog = true;
          return;
        }

        this.generateCancellationInvoice();
      });
  }

  cancellationConfirmed() {
    this.cancellationConfirmDialog = false;
    this.generateCancellationInvoice();
  }

  confirmMarkedAsManuallyOverriden() {
    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t(
        "ReservationBillingStatus.MarkAsManuallyOverridenConfirm"
      ),
      actions: [
        {
          text: this.$t("Confirm"),
          fun: () => {
            this.markAsManuallyOverriden(this.reservationModel.id.toString());
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  markAsManuallyOverriden(reservationId: string) {
    this.markReservationStatusAsOverriden = true;
    Vue.axios
      .put(`/reservations/MarkReservationsAsManuallyOverriden`, {
        reservationIds: reservationId,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t(
            "ReservationBillingStatus.MarkAsManuallyOverridenSuccess"
          ),
          timeout: 5000,
        } as Notification);
        this.reservationModel.invoiceStatusId =
          InvoiceStatusEnum.ManuallyOverriden;
      })
      .finally(() => {
        this.markReservationStatusAsOverriden = false;
      });
  }

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  // new fin doc generation
  @Ref("finDocForm") finDocForm?: FinancialDocumentModalForm;
  showFinDocWarnings(warnings: string[], closeForm = true) {
    if (warnings && warnings.length > 0) {
      warnings.forEach((e) => {
        this.$store.dispatch("showNotification", {
          color: "warning",
          message: e,
          timeout: 30000,
          localize: true,
          actions: closeForm
            ? [
                {
                  text: this.$t("Continue"),
                  fun: () => {
                    return true;
                  },
                },
                {
                  text: this.$t("Cancel"),
                  fun: () => {
                    this.closeFinDocForm();
                    return true;
                  },
                },
              ]
            : undefined,
        } as Notification);
      });
    }
  }
  closeFinDocForm() {
    if (this.finDocForm) {
      this.finDocForm.close();
    }
  }
  invoiceEditingOpen = false;
  deleteDocOnClose = false;
  finDocId = null as number | null;

  async generateGuestInvoice(forceSplit = false) {
    if (!this.activeBusinessUnit || !this.activeCashRegister) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message:
          "FinancialDocument.CreationValidation.MustSelectBusinessUnitAndCashRegister",
        timeout: 5000,
        localize: true,
      } as Notification);
      return;
    }

    if (
      forceSplit ||
      !this.areAllSameProperty ||
      !this.areAllSameAgencyWorkModel ||
      (!this.areAllSameOwner &&
        this.shouldRouteDocumentsForDifferentOwners(
          FinancialDocumentTypesEnum.Racun
        ))
    ) {
      this.invoiceRoutingFinancialDocumentTypeId =
        FinancialDocumentTypesEnum.Racun;
      this.invoiceRoutingIsForCancellation = false;
      this.invoiceRoutingOpen = true;
      return;
    }

    this.isLoading = true;

    Vue.axios
      .post<GenerateInvoiceResultModel>(
        "financialDocuments/CreateGuestInvoiceForReservation",
        {
          culture: this.internalLanguage,
          reservationId: this.reservationModel.id,
          businessUnitId: this.activeBusinessUnit.id,
          cashRegisterId: this.activeCashRegister.id,
          defaultToPropertyBusinessUnit: true,
          overrideRules: [
            "FinancialDocument.Validation.MustHaveTaxExemptionReason",
          ],
        }
      )
      .then((res) => {
        this.reloadFinancialTable();
        this.finDocId = res.data.documentId;
        this.showFinDocWarnings(res.data.warnings);
        this.deleteDocOnClose = true;
        this.invoiceEditingOpen = true;
      })
      .finally(() => (this.isLoading = false));
  }

  async generateCancellationInvoice() {
    if (!this.activeBusinessUnit || !this.activeCashRegister) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message:
          "FinancialDocument.CreationValidation.MustSelectBusinessUnitAndCashRegister",
        timeout: 5000,
        localize: true,
      } as Notification);
      return;
    }

    if (
      !this.areAllSameProperty ||
      !this.areAllSameOwner ||
      !this.areAllSameAgencyWorkModel
    ) {
      this.invoiceRoutingFinancialDocumentTypeId =
        FinancialDocumentTypesEnum.Racun;
      this.invoiceRoutingIsForCancellation = true;
      this.invoiceRoutingOpen = true;
      return;
    }

    this.isLoading = true;

    Vue.axios
      .post<GenerateInvoiceResultModel>(
        "financialDocuments/CreateGuestInvoiceForReservationCancellation",
        {
          culture: this.internalLanguage,
          reservationId: this.reservationModel.id,
          businessUnitId: this.activeBusinessUnit.id,
          cashRegisterId: this.activeCashRegister.id,
          defaultToPropertyBusinessUnit: true,
        }
      )
      .then((res) => {
        this.reloadFinancialTable();
        this.finDocId = res.data.documentId;
        this.showFinDocWarnings(res.data.warnings);
        this.deleteDocOnClose = true;
        this.invoiceEditingOpen = true;
      })
      .finally(() => (this.isLoading = false));
  }

  async generateOffer() {
    if (!this.activeBusinessUnit || !this.activeCashRegister) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message:
          "FinancialDocument.CreationValidation.MustSelectBusinessUnitAndCashRegister",
        timeout: 5000,
        localize: true,
      } as Notification);
      return;
    }

    this.isLoading = true;

    Vue.axios
      .post<GenerateInvoiceResultModel>(
        "financialDocuments/CreateOfferForReservation",
        {
          culture: this.internalLanguage,
          reservationId: this.reservationModel.id,
          businessUnitId: this.activeBusinessUnit.id,
          cashRegisterId: this.activeCashRegister.id,
          defaultToPropertyBusinessUnit: true,
          overrideRules: [
            "FinancialDocument.Validation.MustHaveTaxExemptionReason",
          ],
        }
      )
      .then((res) => {
        this.reloadFinancialTable();
        this.finDocId = res.data.documentId;
        this.showFinDocWarnings(res.data.warnings);
        this.deleteDocOnClose = true;
        this.invoiceEditingOpen = true;
      })
      .finally(() => (this.isLoading = false));
  }

  async generateAdvanceInvoice() {
    if (!this.activeBusinessUnit || !this.activeCashRegister) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message:
          "FinancialDocument.CreationValidation.MustSelectBusinessUnitAndCashRegister",
        timeout: 5000,
        localize: true,
      } as Notification);
      return;
    }

    if (
      !this.areAllSameProperty ||
      !this.areAllSameAgencyWorkModel ||
      (!this.areAllSameOwner &&
        this.shouldRouteDocumentsForDifferentOwners(
          FinancialDocumentTypesEnum.RacunZaPredujam
        ))
    ) {
      this.invoiceRoutingFinancialDocumentTypeId =
        FinancialDocumentTypesEnum.RacunZaPredujam;
      this.invoiceRoutingIsForCancellation = false;
      this.invoiceRoutingOpen = true;
      return;
    }

    this.isLoading = true;

    Vue.axios
      .post<GenerateInvoiceResultModel>(
        "financialDocuments/CreateAdvanceInvoiceForReservation",
        {
          culture: this.internalLanguage,
          reservationId: this.reservationModel.id,
          businessUnitId: this.activeBusinessUnit.id,
          cashRegisterId: this.activeCashRegister.id,
          defaultToPropertyBusinessUnit: true,
        }
      )
      .then((res) => {
        this.reloadFinancialTable();
        this.finDocId = res.data.documentId;
        this.showFinDocWarnings(res.data.warnings);
        this.deleteDocOnClose = true;
        this.invoiceEditingOpen = true;
      })
      .finally(() => (this.isLoading = false));
  }

  async generateDeliveryNote(forceSplit = false) {
    if (!this.activeBusinessUnit || !this.activeCashRegister) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message:
          "FinancialDocument.CreationValidation.MustSelectBusinessUnitAndCashRegister",
        timeout: 5000,
        localize: true,
      } as Notification);
      return;
    }

    if (
      forceSplit ||
      !this.areAllSameProperty ||
      !this.areAllSameOwner ||
      !this.areAllSameAgencyWorkModel
    ) {
      this.invoiceRoutingFinancialDocumentTypeId =
        FinancialDocumentTypesEnum.Otpremnica;
      this.invoiceRoutingIsForCancellation = false;
      this.invoiceRoutingOpen = true;
      return;
    }

    this.isLoading = true;

    Vue.axios
      .post<GenerateInvoiceResultModel>(
        "financialDocuments/CreateDeliveryNoteForReservation",
        {
          culture: this.internalLanguage,
          reservationId: this.reservationModel.id,
          businessUnitId: this.activeBusinessUnit.id,
          cashRegisterId: this.activeCashRegister.id,
          defaultToPropertyBusinessUnit: true,
          overrideRules: [
            "FinancialDocument.Validation.MustHaveTaxExemptionReason",
          ],
        }
      )
      .then((res) => {
        this.reloadFinancialTable();
        this.finDocId = res.data.documentId;
        this.showFinDocWarnings(res.data.warnings);
        this.deleteDocOnClose = true;
        this.invoiceEditingOpen = true;
      })
      .finally(() => (this.isLoading = false));
  }

  get accUnitsEligibleForCommissionInvoice() {
    return this.reservationModel.accomodationUnitTypes.filter(
      (x) =>
        x.ownerId &&
        x.agencyWorkModelId === AgencyWorkModelsEnum.OtherNameAndOtherInvoice
      // TODO: should something like this be added for commission invoices?
      // !x.isInvoicedForOwner &&
    );
  }

  async generateCommissionInvoice(ids: number[]) {
    if (!this.activeBusinessUnit || !this.activeCashRegister) {
      this.$store.dispatch("showNotification", {
        color: "success",
        message:
          "FinancialDocument.CreationValidation.MustSelectBusinessUnitAndCashRegister",
        timeout: 5000,
        localize: true,
      } as Notification);
      return;
    }

    if (ids.length > 0) {
      this.isLoading = true;
      Vue.axios
        .post<GenerateInvoiceResultModelBulk>(
          "financialDocuments/CreateCommissionInvoiceForReservationUnits",
          {
            culture: this.internalLanguage,
            reservationId: this.reservationModel.id,
            reservationUnitIds: ids,
            businessUnitId: this.activeBusinessUnit.id,
            cashRegisterId: this.activeCashRegister.id,
            defaultToPropertyBusinessUnit: true,
          }
        )
        .then((res) => {
          this.reloadFinancialTable();
          if (res.data.documentIds.length === 1) {
            this.finDocId = res.data.documentIds[0];
            this.showFinDocWarnings(res.data.warnings);
            this.deleteDocOnClose = true;
            this.invoiceEditingOpen = true;
          } else {
            this.showFinDocWarnings(res.data.warnings, false);
            this.$store.dispatch("showNotification", {
              color: "success",
              message: "Commission invoices created",
              timeout: 5000,
              localize: true,
            } as Notification);
          }
        })
        .catch(() => {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t(
              "FinancialDocument.CreateCommissionInvoices.Failed"
            ),
            timeout: 5000,
          });
        })
        .finally(() => (this.isLoading = false));
    } else if (this.accUnitsEligibleForCommissionInvoice.length === 1) {
      this.generateCommissionInvoice([
        this.accUnitsEligibleForCommissionInvoice[0].id,
      ]);
    } else {
      this.unitSelectionUnits = this.accUnitsEligibleForCommissionInvoice;
      this.unitSelectionModalAction = this.generateCommissionInvoice;
      this.unitSelectionModalOpen = true;
      return;
    }
  }

  get accUnitsEligibleForOwnersInvoice() {
    return this.reservationModel.accomodationUnitTypes.filter(
      (x) =>
        x.ownerId &&
        x.agencyWorkModelId === AgencyWorkModelsEnum.OwnNameAndOtherInvoice &&
        !x.isInvoicedForOwner &&
        !x.ownerIsLegalEntity
    );
  }

  async generateOwnersInvoice(ids: number[]) {
    if (ids.length > 0) {
      this.isLoading = true;
      Vue.axios
        .post<number[]>(
          "financialDocuments/CreateOwnersInvoiceForReservationUnits",
          {
            culture: this.internalLanguage,
            reservationId: this.reservationModel.id,
            reservationUnitIds: ids,
          }
        )
        .then((res) => {
          this.reloadFinancialTable();

          if (res.data.length === 1) {
            this.finDocId = res.data[0];
            this.deleteDocOnClose = true;
            this.invoiceEditingOpen = true;
          } else {
            this.$store.dispatch("showNotification", {
              color: "success",
              message: "Owner's invoices created",
              timeout: 5000,
              localize: true,
            } as Notification);
          }
        })
        .catch(() => {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: this.$t("FinancialDocument.CreateOwnersInvoices.Failed"),
            timeout: 5000,
          });
        })
        .finally(() => (this.isLoading = false));
    } else if (this.accUnitsEligibleForOwnersInvoice.length === 1) {
      this.generateOwnersInvoice([this.accUnitsEligibleForOwnersInvoice[0].id]);
    } else {
      this.unitSelectionUnits = this.accUnitsEligibleForOwnersInvoice;
      this.unitSelectionModalAction = this.generateOwnersInvoice;
      this.unitSelectionModalOpen = true;
      return;
    }
  }

  invoiceRoutingOpen = false;
  invoiceRoutingFinancialDocumentTypeId = FinancialDocumentTypesEnum.Racun;
  invoiceRoutingIsForCancellation = false;
  get invoiceRoutingDefaults() {
    return {
      reservationId: this.reservationModel?.id ?? 0,
      customerId: this.reservationModel?.customer?.id ?? null,
      customerName: this.reservationModel?.customer?.name ?? "",
      customerIdentificationNumber:
        this.reservationModel?.customer?.identificationNumber ?? "",
      paymentMeansId: this.reservationModel?.paymentMeansId ?? null,
      cardTypeId: this.reservationModel?.cardTypeId ?? null,
    };
  }

  get totalCommisionPrice() {
    const totalUnitPrices =
      this.reservationModel.accomodationUnitTypes
        .filter(
          (x) =>
            x.agencyWorkModelId ===
            AgencyWorkModelsEnum.OtherNameAndOtherInvoice
        )
        .reduce(
          (sum, acc) =>
            sum +
            round(
              round(acc.dayPrices.reduce((dsum, d) => dsum + d.price, 0)) *
                (1 - (acc.discountPercent ?? 0) / 100)
            ),
          0
        ) || 0;

    const totalOwnerFee =
      this.reservationModel.accomodationUnitTypes
        .filter(
          (x) =>
            x.agencyWorkModelId ===
            AgencyWorkModelsEnum.OtherNameAndOtherInvoice
        )
        .reduce(
          (sum, acc) =>
            sum +
            round(
              round(
                acc.dayPrices.reduce((owner, s) => owner + s.inputPrice, 0)
              ) *
                (1 - (acc.discountInputPercent ?? 0) / 100)
            ),
          0
        ) || 0;

    return totalUnitPrices - totalOwnerFee;
  }

  confirmReservation() {
    if (
      this.reservationModel.bookingDate &&
      this.reservationModel.arrivalDate &&
      this.reservationModel.bookingDate.substring(0, 10) >
        this.reservationModel.arrivalDate.toISOString().substring(0, 10)
    ) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: "Reservation.BookingDateMustNotBeAfterArrival",
        timeout: 5000,
        localize: true,
      } as Notification);
    } else if (
      this.reservationModel.bookingDate &&
      this.reservationModel.optionExpirationDate &&
      this.reservationModel.bookingDate.substring(0, 10) >
        this.reservationModel.optionExpirationDate.substring(0, 10)
    ) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: "Reservation.BookingDateMustNotBeAfterOptionExpiration",
        timeout: 5000,
        localize: true,
      } as Notification);
    } else if (
      this.reservationModel.optionExpirationDate &&
      this.reservationModel.arrivalDate &&
      this.reservationModel.optionExpirationDate.substring(0, 10) >
        this.reservationModel.arrivalDate.toISOString().substring(0, 10)
    ) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: "Reservation.OptionExpirationMustNotBeAfterArrival",
        timeout: 5000,
        localize: true,
      } as Notification);
    } else {
      this.isSaving = true;
      Vue.axios
        .put("reservations/" + this.reservationModel.id + "/ConfirmReservation")
        .then(() => {
          this.calendarReload();

          this.$store.dispatch("showNotification", {
            color: "success",
            message: "Reservation.ConfirmSuccess",
            timeout: 5000,
            localize: true,
          } as Notification);

          this.$emit("reservationUpdated");
          this.loadReservation(this.reservationModel.id);
        })
        .finally(() => {
          this.isSaving = false;
        });
    }
  }

  partialConfirmReservation() {
    this.isSaving = true;
    Vue.axios
      .put(
        "reservations/" + this.reservationModel.id + "/PartialConfirmFromOnHold"
      )
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.ConfirmSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  get canPutOnHold() {
    return (
      this.reservationModel.statusId === ReservationStatusEnum.Confirmed &&
      !this.reservationModel.accomodationUnitTypes.some(
        (x) =>
          x.statusId === ReservationStatusEnum.CheckedIn ||
          x.statusId === ReservationStatusEnum.CheckedOut
      )
    );
  }
  reservationPutOnHold() {
    this.isSaving = true;
    Vue.axios
      .put("reservations/" + this.reservationModel.id + "/ReservationPutOnHold")
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.PutOnHoldSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
  partialHoldReservation() {
    this.isSaving = true;
    Vue.axios
      .put(
        "reservations/" + this.reservationModel.id + "/PartialHoldFromConfirmed"
      )
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.PutOnHoldSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  unitSelectionModalOpen = false;
  unitSelectionUnits = [] as ReservationAccUnitModel[];
  unitSelectionModalAction: null | ((ids: number[]) => void) = null;

  get canMarkAsCheckedIn() {
    return (
      (this.reservationModel.statusId === ReservationStatusEnum.Confirmed ||
        this.reservationModel.statusId === ReservationStatusEnum.Hold) &&
      this.reservationModel.accomodationUnitTypes.some((x) => !x.statusId)
    );
  }
  get canReturnToCheckedIn() {
    return this.reservationModel.accomodationUnitTypes.some(
      (x) => x.statusId === ReservationStatusEnum.CheckedOut
    );
  }
  markAsCheckedIn() {
    if (this.reservationModel.accomodationUnitTypes.length === 1) {
      this.markUnitsAsCheckedIn([]);
    } else {
      this.unitSelectionUnits =
        this.reservationModel.accomodationUnitTypes.filter((x) => !x.statusId);
      this.unitSelectionModalAction = this.markUnitsAsCheckedIn;
      this.unitSelectionModalOpen = true;
    }
  }
  returnToCheckedIn() {
    if (this.reservationModel.accomodationUnitTypes.length === 1) {
      this.markUnitsAsCheckedIn([]);
    } else {
      this.unitSelectionUnits =
        this.reservationModel.accomodationUnitTypes.filter(
          (x) => x.statusId === ReservationStatusEnum.CheckedOut
        );
      this.unitSelectionModalAction = this.markUnitsAsCheckedIn;
      this.unitSelectionModalOpen = true;
    }
  }
  markUnitsAsCheckedIn(ids: number[]) {
    this.isSaving = true;
    Vue.axios
      .put("reservations/" + this.reservationModel.id + "/SetCheckedIn", ids)
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.MarkAsCheckedInSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  get canMarkAsCheckedOut() {
    return (
      this.reservationModel.accomodationUnitTypes.some(
        (x) => x.statusId === ReservationStatusEnum.CheckedIn
      ) || this.reservationModel.statusId === ReservationStatusEnum.CheckedIn
    );
  }
  markAsCheckedOut() {
    if (this.reservationModel.accomodationUnitTypes.length === 1) {
      this.markUnitsAsCheckedOut([]);
    } else {
      this.unitSelectionUnits =
        this.reservationModel.accomodationUnitTypes.filter(
          (x) => x.statusId === ReservationStatusEnum.CheckedIn
        );
      this.unitSelectionModalAction = this.markUnitsAsCheckedOut;
      this.unitSelectionModalOpen = true;
    }
  }

  markUnitsAsCheckedOut(ids: number[]) {
    this.isSaving = true;
    Vue.axios
      .put("reservations/" + this.reservationModel.id + "/SetCheckedOut", ids)
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.MarkAsCheckedOutSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  get canMarkAsConfirmed() {
    return (
      (this.reservationModel.accomodationUnitTypes.some(
        (x) => x.statusId === ReservationStatusEnum.CheckedIn
      ) ||
        this.reservationModel.statusId === ReservationStatusEnum.CheckedIn) &&
      this.reservationModel.statusId != ReservationStatusEnum.Hold
    );
  }
  markAsConfirmed() {
    if (this.reservationModel.accomodationUnitTypes.length === 1) {
      this.markUnitsAsConfirmed([]);
    } else {
      this.unitSelectionUnits =
        this.reservationModel.accomodationUnitTypes.filter(
          (x) => x.statusId === ReservationStatusEnum.CheckedIn
        );
      this.unitSelectionModalAction = this.markUnitsAsConfirmed;
      this.unitSelectionModalOpen = true;
    }
  }

  markUnitsAsConfirmed(ids: number[]) {
    this.isSaving = true;
    Vue.axios
      .put("reservations/" + this.reservationModel.id + "/UnsetCheckedIn", ids)
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.BackToConfirmedSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  get isReservationOnHoldAndUnitCheckedInOut() {
    return (
      this.reservationModel.statusId === ReservationStatusEnum.Hold &&
      this.reservationModel.accomodationUnitTypes.some(
        (x) =>
          x.statusId === ReservationStatusEnum.CheckedIn ||
          x.statusId === ReservationStatusEnum.CheckedOut
      )
    );
  }

  get isReservationConfirmedAndUnitCheckInOut() {
    return (
      this.reservationModel.statusId === ReservationStatusEnum.Confirmed &&
      this.reservationModel.accomodationUnitTypes.some(
        (x) =>
          x.statusId === ReservationStatusEnum.CheckedIn ||
          x.statusId === ReservationStatusEnum.CheckedOut
      )
    );
  }

  //reset unit status if reservation is 'On-hold' and unit is checked-in
  markUnitsAsOnHold() {
    this.unitSelectionUnits =
      this.reservationModel.accomodationUnitTypes.filter(
        (x) => x.statusId === ReservationStatusEnum.CheckedIn
      );
    this.unitSelectionModalAction = this.markUnitsAsHold;
    this.unitSelectionModalOpen = true;
  }

  markUnitsAsHold(ids: number[]) {
    this.isSaving = true;
    Vue.axios
      .put(
        "reservations/" + this.reservationModel.id + "/UnsetCheckedInToHold",
        ids
      )
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.BackToHoldSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  cancelReservation() {
    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("Reservation.CancelConfirm"),
      timeout: 5000,
      actions: [
        {
          text: this.$t("Yes"),
          fun: () => {
            this.cancelReservationConfirmed();
            return true;
          },
        },
        {
          text: this.$t("No"),
          fun: () => {
            return true;
          },
        },
      ],
    } as Notification);
  }

  cancelReservationConfirmed() {
    this.isSaving = true;
    this.noOverbookingMessage = true;
    Vue.axios
      .put("reservations/" + this.reservationModel.id + "/CancelReservation")
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.CancelSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  get reservationIsNoShow() {
    let minDate = "";
    if (this.reservationModel.accomodationUnitTypes.length > 0) {
      const units = _.cloneDeep(this.reservationModel.accomodationUnitTypes);
      units.sort(
        (a, b) =>
          DateTime.fromISO(a.arrivalDate).toMillis() -
          DateTime.fromISO(b.arrivalDate).toMillis()
      );
      minDate = units[0].arrivalDate;
    } else {
      return false;
    }

    return (
      !!this.reservationModel.id &&
      this.reservationModel.statusId == ReservationStatusEnum.Confirmed &&
      DateTime.local() >= DateTime.fromISO(minDate)
    );
  }

  get canNoShow() {
    return (
      this.reservationModel.statusId === ReservationStatusEnum.Confirmed &&
      this.reservationModel.accomodationUnitTypes.some((x) => !x.statusId) &&
      (this.reservationModel.arrivalDate ?? new Date())
        .toISOString()
        .substr(0, 10) <= new Date().toISOString().substr(0, 10)
    );
  }

  noShowReservation() {
    if (this.reservationModel.accomodationUnitTypes.length === 1) {
      this.noShowUnits([]);
    } else {
      this.unitSelectionUnits =
        this.reservationModel.accomodationUnitTypes.filter((x) => !x.statusId);
      this.unitSelectionModalAction = this.noShowUnits;
      this.unitSelectionModalOpen = true;
    }
  }

  noShowUnits(ids: number[]) {
    this.isSaving = true;
    Vue.axios
      .put("reservations/" + this.reservationModel.id + "/NoShowUnits", ids)
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.NoShowSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  canResetStatus(statusId: number) {
    if (statusId === ReservationStatusEnum.Hold) {
      return (
        this.reservationModel.statusId != ReservationStatusEnum.Hold &&
        this.reservationModel.statusId != ReservationStatusEnum.Confirmed &&
        this.reservationModel.statusId != ReservationStatusEnum.CheckedIn &&
        this.reservationModel.statusId != ReservationStatusEnum.CheckedOut
      );
    }

    if (statusId === ReservationStatusEnum.Confirmed) {
      return (
        this.reservationModel.statusId === ReservationStatusEnum.Canceled ||
        (this.reservationModel.statusId != ReservationStatusEnum.Hold &&
          this.reservationModel.accomodationUnitTypes.some(
            (x) => x.statusId === ReservationStatusEnum.NoShow
          ))
      );
    }

    return false;
  }

  resetReservationStatus(statusId: number) {
    this.statusToResetToId = statusId;
    if (
      this.reservationModel.statusId === ReservationStatusEnum.Canceled ||
      this.reservationModel.accomodationUnitTypes.length === 1
    ) {
      this.resetUnitsStatus([]);
    } else {
      this.unitSelectionUnits =
        this.reservationModel.accomodationUnitTypes.filter(
          (x) => x.statusId === ReservationStatusEnum.NoShow
        );
      this.unitSelectionModalAction = this.resetUnitsStatus;
      this.unitSelectionModalOpen = true;
    }
  }

  statusToResetToId = 1;
  resetUnitsStatus(ids: number[]) {
    this.isSaving = true;
    Vue.axios
      .put(
        "reservations/" +
          this.reservationModel.id +
          "/ReservationResetStatus/" +
          this.statusToResetToId,
        ids
      )
      .then(() => {
        this.calendarReload();

        this.$store.dispatch("showNotification", {
          color: "success",
          message: "Reservation.ResetSuccess",
          timeout: 5000,
          localize: true,
        } as Notification);

        this.$emit("reservationUpdated");
        this.loadReservation(this.reservationModel.id);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  submitOtaReservationId() {
    this.isSaving = true;
    const data = {
      reservationId: this.reservationModel.id,
      otaReservationId: this.changedOtaReservationId,
    };

    Vue.axios
      .put("reservations/UpdateOtaReservationId", data)
      .then(() => {
        this.reservationModel.otareservationId = this.changedOtaReservationId;
        this.menuOpen = false;
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Reservation.OtaReservationIdChange.Success"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
  @Watch("menuOpen")
  menuOpenChange(fresh: boolean) {
    if (!fresh) {
      this.changedOtaReservationId = this.reservationModel.otareservationId;
    }
  }

  maxLength(max: number) {
    return (v: string) =>
      !v || v.length <= max
        ? true
        : this.$t("Validation.MaxLength", { count: max });
  }

  calendarReload() {
    if (
      this.reservationModel.arrivalDate &&
      this.reservationModel.departureDate &&
      this.fromCalendar
    ) {
      const minArrivalDate =
        this.historicArrivalDate &&
        this.historicArrivalDate.getTime() <
          this.reservationModel.arrivalDate.getTime()
          ? this.historicArrivalDate
          : this.reservationModel.arrivalDate;

      const maxDepartureDate =
        this.historicDepartureDate &&
        this.historicDepartureDate.getTime() >
          this.reservationModel.departureDate.getTime()
          ? this.historicDepartureDate
          : this.reservationModel.departureDate;

      this.$emit("calendarReload", {
        from: DateTime.fromJSDate(minArrivalDate),
        to: DateTime.fromJSDate(maxDepartureDate),
      });
    }
  }
  refreshEVisitorTable() {
    this.eVisitorTableRef?.load();
  }

  refreshReservation() {
    this.paymentsTableRef?.load();
    this.eVisitorTableRef?.load();
    this.loadReservation(this.reservationModel.id);
  }

  setReservationColor() {
    if (this.reservationModel.id) {
      this.isLoading = true;
      this.axios
        .put("reservations/SetReservationColor", {
          reservationId: this.reservationModel.id,
          colorCodeHex: this.reservationModel.colorCodeHex,
        })
        .then(() => {
          this.calendarReload();
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  get showEvisitor() {
    return this.eVisitorIntegrationGetter?.id !== EVisitorIntegrationEnum.None;
  }

  @Action("codebooks/refreshOtas") refreshOtas?: () => Promise<void>;
  @Getter("codebooks/otasWithInactive") otas?: Ota[];

  @Action("codebooks/refreshServiceTypes")
  refreshServiceTypes?: () => Promise<void>;
  @Getter("codebooks/serviceTypes") serviceTypes?: ServiceType[];

  @Action("appParams/refreshAppParams") refreshAppParams?: () => Promise<void>;
  @Getter("appParams/appParams") appParams?: AppParam[];

  @Getter("appParams/routePrepaymentsForOwnNameAndOtherInvoice")
  routePrepaymentsForOwnNameAndOtherInvoice?: boolean;
  @Getter("appParams/routeInvoicesForOwnNameAndOtherInvoice")
  routeInvoicesForOwnNameAndOtherInvoice?: boolean;

  @Getter("financial/settings") financialSettings?: FinancialSettingsType;
  @Getter("appParams/tenantCustomer") tenantCustomer?: TenantCustomerModel;
  @Getter("appParams/tenantGeneratesOwnersInvoices")
  tenantGeneratesOwnersInvoices?: boolean;
  @Getter("appParams/tenantGeneratesDeliveryNotes")
  tenantGeneratesDeliveryNotes?: boolean;
  @Getter("appParams/tenantPaysVat") tenantPaysVat?: boolean;
  @Getter("appParams/tenantPaymentGatewayIntegrationId")
  tenantPaymentGatewayIntegrationId?: number;
  @Getter("appParams/tenantUsesOfficialRates")
  tenantUsesOfficialRates?: boolean;

  @Getter("appParams/tenantOBRsUseRelativePricing")
  tenantOBRsUseRelativePricing?: boolean;

  @Action("codebooks/refreshSalesChannels")
  refreshSalesChannels?: () => Promise<void>;
  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];

  @Getter("auth/claims") claims?: JwtClaims;

  // prettier-ignore
  @Getter("codebooks/unitsOfMeasure") unitsOfMeasure?: any[];
  @Getter("codebooks/currencies") currencies?: Currency[];
  // prettier-ignore
  @Action("codebooks/refreshTaxRates")refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];
  // prettier-ignore
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  @Getter("language/language") language?: string;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("businessUnit/availableBusinessUnits")
  availableBusinessUnits?: BusinessUnit[];

  @Getter("cashRegister/availableCashRegisters")
  availableCashRegisters?: CashRegisterModel[];

  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  @Getter("appParams/tenantUsesBookingEngineBookingConfirmation")
  tenantUsesBookingEngineBookingConfirmation?: boolean;

  scrolledFlag = true;
  @Action("reservation/setGuestsUnchanged") setGuestsUnchanged?: (
    payload: boolean
  ) => Promise<void>;
}
